import { getOrderCachePanel,deleteOrderCache} from "../../services/OrderCacheServices";
import { PedidosContext } from "./PedidosContext"

export const PedidosState = ({ children }) => {

    const getPedidosPanelData = async (searchCli, searchSel, numpag, filas) => {
        let res = await getOrderCachePanel(searchCli, searchSel, numpag, filas);
        return res;
    }

    const deletePedidosData = async (body) => {
        const res = await deleteOrderCache(body)
        return res
    }


    return <PedidosContext.Provider value={{
        getPedidosPanelData,
        deletePedidosData
    }} >
        {children}
    </PedidosContext.Provider>
}